"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Header = require("./Header");
var _Footer = require("./Footer");
var _Form = _interopRequireDefault(require("./Form"));
var _Modal = require("./Modal");
var _Navigation = require("./Navigation");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var AppReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AppReact, _React$Component);
  var _super = _createSuper(AppReact);
  function AppReact() {
    (0, _classCallCheck2.default)(this, AppReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(AppReact, [{
    key: "returnHeading",
    value: function returnHeading() {
      if (this.props.form.showConfirmationPage) {
        // Confirmation State
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "main-heading"
        }, "Please confirm your bank information and authorize enrollment in automated payments:");
      }
      // Edit State
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "main-heading"
      }, "Save time and money by setting up automated payments"), /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-heading"
      }, "When you connect your bank account, money will be automatically withdrawn each month to pay your bill, saving you time and potential late fees."));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        form = _this$props.form,
        siteInfo = _this$props.siteInfo;
      var navigationToNextPage = form.navigationToNextPage;
      var landingPageRedirectTo = siteInfo.landingPageRedirectTo,
        pgId = siteInfo.pgId,
        applicationStatus = siteInfo.applicationStatus,
        loanType = siteInfo.loanType,
        customFlow = siteInfo.customFlow,
        userInfo = siteInfo.userInfo,
        realm = siteInfo.realm;
      if (navigationToNextPage === 'true') {
        if (realm === 'LCYTS' || realm === 'LCK12') {
          // YTS OR K12
          var origin = window.location.origin;
          if (userInfo && userInfo.isPracticeUser) {
            window.location.href = "".concat(origin, "/dashboard?id=").concat(pgId, "&status=").concat(applicationStatus);
          } else {
            window.location.href = "".concat(origin, "/family-center");
          }
        } else {
          // LCPS
          if (userInfo && userInfo.isPracticeUser) {
            window.location.href = "".concat(landingPageRedirectTo, "dashboard?analyticsTrack=%2Fdashboard_done%26id=").concat(pgId, "%26status=").concat(applicationStatus, "%26loantype=").concat(loanType, "%26customFlow=").concat(customFlow);
          } else {
            window.location.href = "".concat(landingPageRedirectTo, "patient_center?analyticsTrack=%2Fpatient_center_done");
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "ach-enrollment"
      }, /*#__PURE__*/_react.default.createElement(_Header.Header, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "ach-enrollment-content"
      }, this.returnHeading(), /*#__PURE__*/_react.default.createElement(_Form.default, null), /*#__PURE__*/_react.default.createElement(_Navigation.Navigation, null)), /*#__PURE__*/_react.default.createElement(_Modal.Modal, null), /*#__PURE__*/_react.default.createElement(_Footer.Footer, null));
    }
  }]);
  return AppReact;
}(_react.default.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    form: state.form,
    siteInfo: state.siteInfo
  };
};
AppReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  form: _propTypes.default.shape({
    navigationToNextPage: _propTypes.default.string,
    loanId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    showConfirmationPage: _propTypes.default.bool
  })
};
var mapDispatchToProps = {};
var App = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppReact);
exports.App = App;
